import { MuiGrid } from '@/features/shared/material-ui';
import { MarketoControlsDistribution } from '@/utils/constants';
import React from 'react';
import { getColRatio } from '../utils';
import MarketoControl from './MarketoControl';

const MarketoRow = ({
  theme,
  onChange,
  value,
  classes,
  spacing = 2,
  controls = [],
  controlsDistribution,
  marketoInstance,
  className,
}: any) => {
  const isSingleColumn = React.useMemo(
    () => MarketoControlsDistribution.SingleColumn.includes(controlsDistribution),
    [controlsDistribution],
  );

  const handleChange = React.useCallback(
    ({ value: inputValue, name, id, target }: any) => {
      onChange({ value: inputValue, name, id, target });
    },
    [onChange],
  );

  const els = React.useMemo(() => {
    return controls.map((row: any) =>
      row.map((col: any, idx: number) => (
        <MuiGrid
          item
          key={col.attributes?.id || `col_${idx}`}
          xs={12}
          sm={getColRatio(row.length, isSingleColumn)}
        >
          {Array.isArray(col) ? (
            <MarketoRow
              theme={theme}
              onChange={onChange}
              value={value}
              controls={col}
              classes={classes}
              marketoInstance={marketoInstance}
            />
          ) : (
            <MarketoControl
              theme={theme}
              onChange={handleChange}
              value={value}
              {...col}
              classes={classes}
              isSingleColumn={isSingleColumn}
              marketoInstance={marketoInstance}
            />
          )}
        </MuiGrid>
      )),
    );
  }, [classes, controls, handleChange, isSingleColumn, marketoInstance, onChange, theme, value]);

  return (
    <MuiGrid container spacing={spacing} className={className}>
      {els}
    </MuiGrid>
  );
};

export default React.memo(MarketoRow);
